import JsFunction from './JsFunction';

export default class ChangeURLFunction extends JsFunction {
  inputDataTemplate = '';

  sessionStorageSet = ``;

  constructor(method, annotations, htmlDom, services) {
    super(method, annotations);
    this.inputDataTemplate = method.inputDataTemplate;
    this.createSessionStorageSet(htmlDom, services);
  }

  createTransitionWithId() {

    this.functionality = this.functionality.replace('<findId>',
    `
      let transitionId = window.location.href.split('/').at(-1);
      let parentId = "";
      const storedData = window.localStorage.getItem("data");
      const newMap = new Map(JSON.parse(storedData));
      newMap.forEach((value, key) => {
        if (
          document.getElementById(key) !== null &&
          document
            .getElementById(key)
            .contains(document.getElementById("${this.compId}")) === true &&
            document.getElementById(key).contains(document.getElementById(parentId)) === false
        ) {
          transitionId = value._id;
          parentId = key;
        }
      });
    `);
    this.functionality = this.functionality.replace('<assignId>','+ transitionId');
    
    return `${this.functionality.replace(this.inputDataTemplate, `/`)}`;

  }

  printFunction(inputParams) {
    super.clearfunctionNextTemplate();
    this.functionality = this.functionality.replace(`<sessionStorageParams>`, this.sessionStorageSet);
    if ( (!inputParams && this.transitionById !== true ) || (inputParams && inputParams.typeId === '') ) {
      this.functionality = this.functionality.replace('<findId>','');
      this.functionality = this.functionality.replace('<assignId>','');
      return this.functionality.replace(this.inputDataTemplate, '');
    }
    if (inputParams && inputParams.typeId && this.transitionById === true ) {
      this.functionality = this.functionality.replace('<findId>','');
      this.functionality = this.functionality.replace('<assignId>','');
      return `${this.functionality.replace(this.inputDataTemplate, `/'+${inputParams.typeId}+'`)}`;
    }
    if ( this.transitionById === true) return this.createTransitionWithId();

    
    return '';
  }

  createSessionStorageSet(htmlDom, services){
    const nodeServiceInputs = htmlDom.querySelectorAll('[service-name]');
    let sessionStorageSet = '';
    let insideQueryParamsServices =  {};
    let insidePushHistoryParams = '';


    if(nodeServiceInputs.length > 0 ){
      sessionStorageSet = `sessionStorage.setItem('serviceData',JSON.stringify( { <insideQueryParams/> }));`;
    } 

    nodeServiceInputs.forEach( (node) => {

      let currentServiceUrl = services[0].services_requests.filter( service => service.name === node.getAttribute('service-name')).map(service => service.url)[0];

      if(!insideQueryParamsServices[`'${currentServiceUrl}'`]){
        insideQueryParamsServices[`'${currentServiceUrl}'`] = { headers : {} , queryParams: {}, bodyParams: {}};
      }

      insideQueryParamsServices[`'${currentServiceUrl}'`][node.getAttribute('type-param')][node.getAttribute('request-param')] =  `document.getElementById('${node.getAttribute('id')}').value`;
    })

    const servicesNames = Object.keys(insideQueryParamsServices);
    servicesNames.forEach ( (serviceUrl, index) => {
      
      if(Object.keys(insideQueryParamsServices[serviceUrl].headers).length === 0){
        delete insideQueryParamsServices[serviceUrl]['headers'];
      }

      if(Object.keys(insideQueryParamsServices[serviceUrl].bodyParams).length === 0){
        delete insideQueryParamsServices[serviceUrl]['bodyParams'];
      }

      if(Object.keys(insideQueryParamsServices[serviceUrl].queryParams).length === 0){
        delete insideQueryParamsServices[serviceUrl]['queryParams'];
      }

      if(index>0) insidePushHistoryParams += ','
      insidePushHistoryParams += ` ${serviceUrl} : ${JSON.stringify(insideQueryParamsServices[serviceUrl])}`
      
    })

    this.sessionStorageSet = sessionStorageSet;
    this.sessionStorageSet = this.sessionStorageSet.replace( `<insideQueryParams/>`, insidePushHistoryParams);
    this.sessionStorageSet = this.sessionStorageSet.toString().replaceAll(`"document`,' document');
    this.sessionStorageSet = this.sessionStorageSet.toString().replaceAll(`value"`,'value'); 
  }

}
